export enum FileTypes {
	// XML = 'XML',
	CSV = 'CSV',
	// JSON = 'JSON',
	// XLSX = 'XLSX',
	SQL = 'SQL',
	SERVICE = 'SERVICE',
	EMAIL = 'EMAIL'
}

